// Báo sự cố (dữ liệu mẫu theo board Mint-Mov-Phone2 khung "Báo sự cố"). Chỉ giả lập trong bộ nhớ.

export type P0Id = 'acc' | 'brk' | 'port' | 'rf';

export const P0S: readonly { id: P0Id; label: string }[] = [
  { id: 'acc', label: 'Tai nạn' },
  { id: 'brk', label: 'Hỏng xe' },
  { id: 'port', label: 'Kẹt cảng' },
  { id: 'rf', label: 'Cont lạnh mất điện' },
];

export const MINOR = ['Kẹt xe, có thể trễ giờ', 'Kho chưa nhận hàng / chờ lâu', 'Cont hư, bẩn, sai loại', 'Khác'] as const;

export interface Incident { id: P0Id; label: string; time: string; ack: boolean }
export interface TimelineStep { label: string; time: string; on: boolean; first: boolean }

/** Tiến trình xử lý P0: gửi kèm GPS → điều độ nhận → leo thang sau 15 phút (CS job nếu cont lạnh). */
export function timeline(inc: Incident, duty = 'THANH'): TimelineStep[] {
  const steps: TimelineStep[] = [
    { label: 'Đã gửi kèm GPS', time: inc.time, on: true, first: true },
    { label: inc.ack ? `${duty} (điều độ trực) đã nhận · đang gọi lại` : `Chờ ${duty} nhận…`, time: inc.ack ? inc.time : '', on: inc.ack, first: false },
    { label: 'Sau 15 phút chưa nhận: chuyển PHONG', time: '', on: false, first: false },
    { label: 'Vẫn chưa nhận: báo BOD PHILIP', time: '', on: false, first: false },
  ];
  if (inc.id === 'rf') steps.push({ label: 'Đã báo CS phụ trách job (cont lạnh)', time: inc.time, on: true, first: false });
  return steps;
}

export function minorValid(text: string): boolean {
  return text.trim().length > 0;
}
